import { Account, TLenderId, TTransactionId } from '/src/lib/models';
import { TBaseResponse } from '/src/lib/types';

/**
 * List Accounts API response.
 */
export type TListAccountsResponse = TBaseResponse<Account[]>;

/**
 * Get Account API response.
 */
export type TGetAccountResponse = TBaseResponse<Account>;

/**
 * Create Account page form data.
 */
export type CreateAccountForm = {
  /**
   * Account balance
   */
  amount: number;
  /**
   * Effective date of new Account
   */
  effectiveDate: Date;
};

/**
 * Create Account API request.
 */
export type TCreateAccountRequest = {
  /**
   * The Account's Lender ID
   */
  _id: TLenderId;
  /**
   * Account balance
   */
  amount: number;
  /**
   * Effective date of the new Account
   */
  effectiveDate: Date;
};

/**
 * Create Account API response.
 */
export type TCreateAccountResponse = TBaseResponse<Account>;

/**
 * Update Account page form data.
 */
export type UpdateAccountForm = {
  /**
   * Account balance
   */
  amount: number;
};

/**
 * Update Account API request.
 */
export type TUpdateAccountRequest = {
  /**
   * The Account's Lender ID
   */
  _id: TLenderId;
  /**
   * Account balance
   */
  amount: number;
  /**
   * ID of the Transaction that triggered this Account update
   */
  transactionId: TTransactionId;
};

/**
 * Update Account API response.
 */
export type TUpdateAccountResponse = TBaseResponse<Account>;

/**
 * Delete Account API response.
 */
export type TDeleteAccountResponse = TBaseResponse<Account>;
